import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";

import { Link } from "react-router-dom";

import Modal from "react-responsive-modal";
import {
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  Col
} from "reactstrap";
import Select from "react-select";
import Datetime from 'react-datetime';
import SweetAlert from "react-bootstrap-sweetalert";

// koneksi
import { ID_DESA, JENIS_DESA, Get, PostMain, GetMain, DeleteMain } from "../function/Koneksi";

// css files
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

const frmInput = {
  uuid: '',
  id_desa: '',
  nama_surat: '',
  keterangan: '',
  file: '',
  link_gambar: '',
  status: '',
};

class RiwayatPenomoran extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataPengaturanAplikasi: [],
      pagination: [],
      status: {
        form: false,
        btnForm: false,
        btnAksi: false,
      },
      awal: "",
      sebelum: "",
      hal: [],
      setelah: "",
      akhir: "",
      dt: frmInput,
      loading: true,
      loadingPreview: false,
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",

      // Cari Data
      dataCari: '',

      // data modal
      frmJenisDownload: [
        {
          value: 'Cetak Nomor Surat',
          label: 'Cetak Nomor Surat',
        },
        {
          value: 'Cetak Nomor Surat dan Detail Riwayat',
          label: 'Cetak Nomor Surat dan Detail Riwayat',
        },
      ],
      selectedJenisDownload: null,
      selectedYear: new Date().getFullYear(),
      selectedDetail: [],
    };
  }

  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  // =================================================

  // ================== Ambil data dari db untuk table ==================
  fetchPengaturanAplikasi = () => {
    Get("pengaturan-aplikasi", null, dtkat => {
      this.setState({
        loading: true,
      })

      if (dtkat.results !== null) {
        this.setState({
          dataPengaturanAplikasi: dtkat.results,
          konfigurasi_nomor: dtkat.results.konfigurasi_nomor,
        });

        this.fetch({ page: null, where: [], jenis: dtkat.results.konfigurasi_nomor });
      }
      else{
        this.setState({
          loading: false,
        });
      }
    });
  };

  fetch = (params = {}) => {
    console.log('apa ini bos')
    console.log(params)
    this.setState({ loading: true })
    let link = "";
    
    if (params.page) {
      switch (params.page) {
        case ">>":
          link =
            "?page=" +
            Math.ceil(
              this.state.pagination.total / this.state.pagination.per_page
            );
          break;
        case ">":
          link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
          break;
        case "<":
          link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
          break;
        case "<<":
          link = "?page=1";
          break;
        default:
          link = "?page=" + params.page;
          break;
      }
    }

    let setLink = '';
		if (link) {
			setLink = `${link}&q=${this.state.dataCari}`
		}
		else {
			setLink = `?q=${this.state.dataCari}`
		}

    let linkFetchData = 'penomoran'
    if(this.state.konfigurasi_nomor === 'Jenis Surat'){
      linkFetchData = 'get-jenis-surat-aktif'
    }
    else if(this.state.konfigurasi_nomor === 'Kategori Surat'){
      linkFetchData = 'konfigurasi-nomor'
    }

    Get(linkFetchData + setLink, null, dtkat => {
      console.log('fetch data')
      console.log(dtkat)
      if(dtkat.results){
        this.setState({ 
          data: this.state.konfigurasi_nomor === 'Nomor Berurut' ? [dtkat.results.data[0]] : dtkat.results.data, 
          pagination: dtkat.results, 
          loading: false, 
        });
        this.pagination(dtkat.results);
      }
      else{
        this.setState({ loading: false });
      }
    });

  };

  // Pagination
  pagination = data => {
    // const data = this.state.pagination; 
    let awal = "";
    let hal = [];
    let sebelum = "";
    let setelah = "";
    let akhir = "";
    if (data.total > 0) {
      let start = 1;
      let end = 5;
      let n = 0;
      let p = 0;
      if (data.current_page <= 3) {
        start = 1;
        end = 5;
        if (data.last_page > data.current_page) {
          n = data.current_page + 1;
        }
      } else {
        p = data.current_page - 1;
        n = data.current_page + 1;
        start = data.current_page - 2;
        end = data.current_page + 2;
      }
      if (end >= data.last_page - 2) {
        p = data.current_page - 1;
        if (start >= 5) {
          start = data.last_page - 4;
        }
        end = data.last_page;
      }

      for (let i = start; i <= end; i++) {
        let warna = "primary-custom";
        if (i === data.current_page) {
          warna = "danger";
        }
        hal.push(
          <a
            href={() => false}
            onClick={() => this.fetch({ page: i })}
            className={
              "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            }
          >
            {i}
          </a>
        );
      }
      if (p > 0) {
        sebelum = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: p })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<"}
          </a>
        );
      }
      if (n > 0) {
        setelah = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: n })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">"}
          </a>
        );
      }
      awal = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: 1 })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {"<<"}
        </a>
      );
      akhir = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: data.last_page })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {">>"}
        </a>
      );
    }
    this.setState({ awal, sebelum, hal, setelah, akhir });
  };

  // Cari Data Table
  cariData = e => {
    if (e.key === 'Enter') {
      this.setState({ 
        dataCari: e.target.value,
      });

      setTimeout(
        function() {
          this.fetch({ page: null, where: [], jenis: this.state.konfigurasi_nomor });
        }.bind(this),
        500
      );
    }
  }

  // ========================= upload file ======================================

  // ================== downloadData data ==================
  downloadData = () => {

    this.setState({ loadingPreview: true })

    let linkDownload = ''
    let statusDetail = false
    let statusSelectJenis = false

    if(this.state.selectedJenisDownload){
      statusSelectJenis = true
      
      if(this.state.selectedJenisDownload.value === 'Cetak Nomor Surat dan Detail Riwayat'){
        statusDetail = true
      }
    }

    if(this.state.konfigurasi_nomor === 'Jenis Surat'){
      linkDownload = localStorage.getItem('SET_API_URL') + 'penomoran-jenis/export?tahun='+this.state.selectedYear+'&detail_surat='+statusDetail
    }
    else if(this.state.konfigurasi_nomor === 'Kategori Surat'){
      linkDownload = localStorage.getItem('SET_API_URL') + 'konfigurasi-nomor/export?tahun='+this.state.selectedYear+'&detail_surat='+statusDetail
    }

    if(statusSelectJenis){
      let token = sessionStorage.getItem("access_token")
        ? sessionStorage.getItem("access_token")
        : "public";
  
      fetch(linkDownload, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/xlsx',
          'Authorization': 'Bearer ' + token,
        },
      })
        // .then((response) => response.blob())
        .then((response) => {
          console.log('apa bos 1')
          console.log(response)
          if (response.status == 200) {
            return response.blob()
          }
          this.setState({
            loadingPreview: false,
            show: true,
            basicType: 'danger',
            basicTitle: 'Download File',
            pesanAlert: 'Gagal download file'
          });
          throw new Error('Something went wrong');
        })
        .then((blob) => {
          console.log('apa bos 2')
          console.log(blob)
          // Create blob link to download
          const url = window.URL.createObjectURL(
            new Blob([blob]),
          );
          const link = document.createElement('a');
          link.href = url;
  
          link.setAttribute(
            'download',
            `Rekap Penomoran Surat Tahun ${this.state.selectedYear}.xlsx`,
          );
  
          // Append to html link element page
          document.body.appendChild(link);
  
          // Start download
          link.click();
  
          // Clean up and remove the link
          link.parentNode.removeChild(link);
          
          setTimeout(function () {
            this.tutupForm()
            this.setState({
              loadingPreview: false,
              loading: false,
              show: true,
              basicType: 'success',
              basicTitle: 'Download File',
              pesanAlert: 'Berhasil download file'
            })
          }.bind(this), 2000)
        })
        .catch((e) => {
          console.log('apa bos 3')
          console.log(e)
          this.setState({
            loadingPreview: false,
            loading: false,
            show: true,
            basicType: 'danger',
            basicTitle: 'Download File',
            pesanAlert: 'Gagal download file'
          });
        })
        ;
    }
    else{
      this.setState({
        loadingPreview: false,
        show: true,
        basicType: 'danger',
        basicTitle: 'Download File',
        pesanAlert: 'Pilih Jenis Download Terlebih Dahulu'
      });
    }
  };
  // ========================================================================

  bukaForm = () => {
    this.setState({
      status:{
          ...this.state.status,
          form: true,
      },
    })
  };

  tutupForm = () => {
    this.setState({
      status:{
        ...this.state.status,
        form: false,
      },
      selectedJenisDownload: null,
      selectedYear: new Date().getFullYear(),
    })
    this.forceUpdate();
  };

  changeSelectValue = (e, jenis) => {
    if (e) {
      this.setState({ [jenis]: e });
    } else {
      this.setState({ [jenis]: null });
    }
    this.forceUpdate();
  };

  changeCheck = (e, parent, jenis) => {
    if (e) {
      this.setState({ 
        [parent]:{
          ...this.state[parent],
          [jenis]: e.target.checked,
        }
      });
    } else {
      this.setState({ 
        [parent]:{
          ...this.state[parent],
          [jenis]: null 
        }
      });
    }
    this.forceUpdate();
  };

	handleChangeInputText = (e, parent) => {
		this.setState({
      dt:{
        ...this.state.dt,
        [parent]: e.target.value,
      }
    })
	};

  componentDidMount() {
    this.fetchPengaturanAplikasi({ page: null, where: [] });
  }

  getCurrentYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    console.log('blablabla')
    return currentYear;
  };

  render() {

    console.log('data render')
    console.log(this.state.selectedDetail)
    console.log(this.state.selectedYear)
    console.log(this.state.data)
    console.log(this.state.dataPengaturanAplikasi)
    console.log(this.state.konfigurasi_nomor)
    var data = this.state.data;

    const columns = [
      {
        dataField: "tahun",
        text: "Tahun",
        sort: true,
        headerAlign: "center",
        align: "center",
        style: {
          width: '100px'
        }
      },
      {
        dataField: "nomor",
        text: "Nomor Surat",
        sort: true,
        headerAlign: "center",
        align: "center"
      },
    ];
    
    const columnsJenisSurat = [
      {
        dataField: "no",
        text: "No",
        headerAlign: 'center',
        align: 'center',
        formatter: (key, obj, index) => {
          let current_pagenum = this.state.pagination.current_page;
          let total_records_per_page = this.state.pagination.per_page;
          let row_index = (index + 1);
          let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
          return serial_num;
        }
      },
      {
        dataField: "nama_surat",
        text: "Nama",
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: "jenis_layanan",
        text: "Kategori",
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: "id_jabatan_perangkat",
        text: "Nomor Terakhir",
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, obj) => {
          let show = 0;
          if(obj.pengaturan_surat && obj.pengaturan_surat.nomor_terakhir){
            show = obj.pengaturan_surat && obj.pengaturan_surat.nomor_terakhir.nomor
          }
          return show;
        },
        isDummyField: true,
        sort: true
      },
    ];
    
    const columnsKategoriSurat = [
      {
        dataField: "no",
        text: "No",
        headerAlign: 'center',
        align: 'center',
        formatter: (key, obj, index) => {
          let current_pagenum = this.state.pagination.current_page;
          let total_records_per_page = this.state.pagination.per_page;
          let row_index = (index + 1);
          let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
          return serial_num;
        }
      },
      {
        dataField: "label",
        text: "Nama Kategori",
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: "data_nomor",
        text: "Nomor Terakhir",
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, obj) => {
          let show = 0;
          if(obj.data_nomor && obj.data_nomor.nomor){
            show = obj.data_nomor.nomor
          }
          return show;
        },
        isDummyField: true,
        sort: true
      },
    ];

    return (
      <div>
        {/* <Breadcrumb title="Penguna" parent="Admin" /> */}
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          onConfirm={this.closeAlert}
        >
          {this.state.pesanAlert}
        </SweetAlert>

        {this.state.alert}

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mb-0">
                {
                  this.state.konfigurasi_nomor && this.state.konfigurasi_nomor === 'Nomor Berurut'
                  ? ''
                  : 
                  <>
                    <div className="card-header">
                      <div className="row">
                        <div className="col-sm-6">
                          <input
                            type="text"
                            className="form-control"
                            id="cariTable"
                            placeholder={this.state.konfigurasi_nomor && this.state.konfigurasi_nomor === 'Jenis Surat'?"Cari berdasarkan nama surat atau kategori":"Cari berdasarkan kategori surat"}
                            onKeyPress={this.cariData}
                          />
                        </div>
                        <div className="col-sm-3">
                          <Datetime
                            inputProps={{ 
                                placeholder: 'Pilih Tahun', 
                            }}
                            name="filter_tahun"
                            locale="id-ID"
                            timeFormat={false}
                            dateFormat="YYYY"
                            input={true}
                            closeOnTab={true}
                            onChange={e => {
                              if (typeof e.isValid !== 'undefined' && e._isValid) {
                                this.setState({
                                  selectedYear: e.format('YYYY')
                                })
                              }
                            }}
                          />
                        </div>
                        <div className="col-sm-3 text-right">
                          <Button
                            size="sm"
                            color="success"
                            className="btn-square"
                            onClick={() => {
                              this.bukaForm();
                            }}
                          >
                            <i className="fa fa-download" /> Download
                          </Button>
                        </div>
                      </div>
                    </div>
                  </>
                }
                <div className="card-body datatable-react">
                  {this.state.loading ? (
                    <div className="row">
                      <div className="col-sm-12" align="center">
                        <img
                          alt="loading"
                          src={require("../assets/images/tes-loading.gif")}
                          style={{
                            borderRadius: "10px",
                            width: '100px'
                          }} />
                      </div>
                    </div>
                  ) : data.length > 0 ? (
                    <>
                      {
                        this.state.konfigurasi_nomor === 'Nomor Berurut'
                        ? 
                        <>
                          <div className="row mt-4" style={{ justifyContent: 'center' }}>
                            <div className="col-sm-4">
                              <BootstrapTable keyField="id" data={data} columns={columns} />
                            </div>
                          </div>
                        </>
                        : 
                        <>
                          <BootstrapTable keyField="id" data={data} columns={this.state.konfigurasi_nomor && this.state.konfigurasi_nomor === 'Jenis Surat'? columnsJenisSurat : this.state.konfigurasi_nomor && this.state.konfigurasi_nomor === 'Kategori Surat' ? columnsKategoriSurat : columns} />
                          <div className="pull-right text-white">
                            {this.state.awal}
                            {this.state.sebelum}
                            {this.state.hal.map(dt => {
                              return dt;
                            })}
                            {this.state.setelah}
                            {this.state.akhir}
                          </div>
                        </>
                      }
                    </>
                  ) : (
                    <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        {/* Loading preview */}
        <SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
        <Modal
          size="lg"
          open={this.state.status.form}
          onClose={this.tutupForm}
          styles={{ modal: { width: "80%" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div size="lg" className="modal-header">
            <h5 className="modal-title">Download Riwayat Nomor Surat</h5>
          </div>
          <Form className="theme-form">
            <div className="modal-body">
              <FormGroup className="row">
                <Label
                  className="col-sm-3 col-form-label"
                  htmlFor="inputEmail3"
                >
                  Jenis Download
                </Label>
                <Col sm="9">
                  <Select
                    classNamePrefix="select"
                    onChange={(e) => this.changeSelectValue(e, 'selectedJenisDownload')}
                    value={this.state.selectedJenisDownload}
                    name="pilih_jenis_download"
                    options={this.state.frmJenisDownload}
                    placeholder="Pilih Jenis Download"
                    isClearable
                  />
                </Col>
              </FormGroup>
              {/* Detail Cetak */}
              {/* {
                this.state.selectedJenisDownload && this.state.selectedJenisDownload.value === 'Cetak Nomor Surat dan Detail Riwayat'
                ?
                  <FormGroup className="row">
                    <Label className="col-sm-3 col-form-label">Berdasarkan Data Kependudukan</Label>
                    <Col sm='9'>
                        <div className="form-group m-checkbox-inline mb-0 sm-mb-checkbox" style={{ paddingLeft: '15px' }}>
                            <div className="checkbox checkbox-primary">
                              <Input name='checkbox' id="inline-form-1" type="checkbox" defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','nik')}/>
                              <Label className="mb-0" htmlFor="inline-form-1">NIK</Label>
                            </div>
                            <div className="checkbox checkbox-primary">
                              <Input name='checkbox' id="inline-form-2" type="checkbox"defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','nama')}/>
                              <Label className="mb-0" htmlFor="inline-form-2">Nama</Label>
                            </div>
                            <div className="checkbox checkbox-secondary">
                              <Input name='checkbox' id="inline-form-3" type="checkbox" defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','jenis_kelamin')}/>
                              <Label className="mb-0" htmlFor="inline-form-3">Jenis Kelamin</Label>
                            </div>
                            <div className="checkbox checkbox-secondary">
                              <Input name='checkbox' id="inline-form-4" type="checkbox" defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','alamat')}/>
                              <Label className="mb-0" htmlFor="inline-form-4">Alamat</Label>
                            </div>
                            <div className="checkbox checkbox-secondary">
                              <Input name='checkbox' id="inline-form-5" type="checkbox" defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','agama')}/>
                              <Label className="mb-0" htmlFor="inline-form-5">Agama</Label>
                            </div>
                            <div className="checkbox checkbox-secondary">
                              <Input name='checkbox' id="inline-form-6" type="checkbox" defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','status_perkawinan')}/>
                              <Label className="mb-0" htmlFor="inline-form-6">Status Perkawinan</Label>
                            </div>
                            <div className="checkbox checkbox-secondary">
                              <Input name='checkbox' id="inline-form-7" type="checkbox" defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','pendidikan_terakhir')}/>
                              <Label className="mb-0" htmlFor="inline-form-7">Pendidikan Terakhir</Label>
                            </div>
                            <div className="checkbox checkbox-secondary">
                              <Input name='checkbox' id="inline-form-8" type="checkbox" defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','pekerjaan')}/>
                              <Label className="mb-0" htmlFor="inline-form-8">Pekerjaan</Label>
                            </div>
                            <div className="checkbox checkbox-secondary">
                              <Input name='checkbox' id="inline-form-9" type="checkbox" defaultChecked = {false} onChange={(e) => this.changeCheck(e, 'selectedDetail','shdk')}/>
                              <Label className="mb-0" htmlFor="inline-form-9">Status Hubungan Dalam Keluarga</Label>
                            </div>
                        </div>
                    </Col>
                  </FormGroup>
                :''
              } */}
              
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-warning"
                disabled={this.state.status.btnForm}
                onClick={this.tutupForm}
              >
                Tutup
              </button>
              <Button
                color="success"
                onClick={() => {
                  this.downloadData()
                }}
                target="blank"
              >
                <span style={{ color: 'white' }}>Download</span>
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default RiwayatPenomoran;